import React from 'react';

import Modal from 'shared/components/modal';

interface Props {
  hideModal: () => void;
}

const HighSchoolRequestedModal = ({hideModal}: Props) => (
  <>
    <Modal.TextHeader>We&apos;re on it!</Modal.TextHeader>
    <Modal.Body>
      We received your request and will send an email with more information about your school within
      1 business day.
    </Modal.Body>
    <Modal.Footer
      primaryButton={{
        text: 'Done',
        onClick: hideModal,
        type: 'submit',
      }}
    />
  </>
);

export default HighSchoolRequestedModal;
